import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { dropdownTitle, selectContainerStyle } from "./orderDetailsStyles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

type DatePickerProps = {
  selectedDate: moment.Moment | null;
  setSelectedDate: (val: moment.Moment | null) => void;
};

export const DatePicker: FC<DatePickerProps> = ({
  selectedDate,
  setSelectedDate,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Box sx={{ flexDirection: "row" }}>
        <Typography sx={dropdownTitle} mb={"30px"}>
          Update ETA
        </Typography>
        <MuiDatePicker
          value={selectedDate}
          onChange={(newValue) => {
            setSelectedDate(newValue);
          }}
          format="DD/MM/YYYY"
          disablePast={!selectedDate}
          slots={{
            openPickerIcon: KeyboardArrowDownIcon,
          }}
          sx={{ "& .MuiInputBase-root": selectContainerStyle }}
        />
      </Box>
    </LocalizationProvider>
  );
};
